// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_2g14t","badgeButtonWrapper":"_2g14t","badge-button":"_2tzuk","badgeButton":"_2tzuk","badge":"_1XPfA"};